// extracted by mini-css-extract-plugin
module.exports = {"home":"page_home__cWXv9","main":"page_main__gXe_t"};